import {Selector} from '@ngxs/store';
import {IStripePlan, IStripeViewSettings, ISubscription} from '@interfaces/subscription-plan';
import {IPaymentMethod} from '@interfaces/payment-method';
import {IInvoice} from '@interfaces/Invoice';
import {PaymentIntent} from '@stripe/stripe-js';
import {PaymentStateModel} from './payment-state.model';
import {PaymentState} from './payment.state';

export class PaymentSelectors {
  @Selector([PaymentState])
  static getUserSubscription(state: PaymentStateModel): ISubscription | null {
    return state.userSubscription;
  }

  @Selector([PaymentState])
  static getStripePlans(state: PaymentStateModel): IStripePlan[] {
    return state.stripePlans;
  }

  @Selector([PaymentState])
  static getSelectedPlan(state: PaymentStateModel): IStripePlan | null {
    return state.selectedPlan;
  }

  @Selector([PaymentState])
  static getPaymentMethods(state: PaymentStateModel): IPaymentMethod[] {
    return state.paymentMethods;
  }

  @Selector([PaymentState])
  static getDefaultPaymentMethod(state: PaymentStateModel): IPaymentMethod | null {
    return state.defaultPaymentMethod;
  }

  @Selector([PaymentState])
  static getStripeViewSettings(state: PaymentStateModel): IStripeViewSettings | null {
    return state.stripeViewSettings;
  }

  @Selector([PaymentState])
  static getStripeInvoices(state: PaymentStateModel): IInvoice[] {
    return state.invoices;
  }

  @Selector([PaymentState])
  static getDevicesBySubscribe(state: PaymentStateModel): number {
    return state.devicesBySubscribe;
  }

  @Selector([PaymentState])
  static getPaymentIntent(state: PaymentStateModel): PaymentIntent | null {
    return state.paymentIntent;
  }
}
